import React from 'react'

export const PageNotFound = () => {
  return (
    <div className='text-center container'>
      <h1 className='text mt-5'>4<span className='text-danger'>0</span>4</h1>
      <p>Page Not Found!!</p>
      <p className='w-50 mx-auto text-muted'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus, quae. Quisquam deleniti ducimus necessitatibus, voluptas corporis eos, quibusdam tempora, porro doloremque molestiae accusamus. Expedita hic pariatur, libero modi atque dolorum?</p>
    </div>
  )
}
